/* libs/shared/src/lib/components/code-ai-assistant/code-ai-assistant.component.scss */
.code-ai-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  animation: fadeIn 0.3s ease;
}
.code-ai-modal-content {
  width: 500px;
  height: 100vh;
  background-color: #ffffff;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  animation: slideInRight 0.4s ease-in-out;
  position: relative;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideInRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes slideOutRight {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.code-ai-modal.closing {
  pointer-events: none;
}
.code-ai-modal.closing .code-ai-modal-content {
  animation: slideOutRight 0.4s ease-in-out forwards;
}
.code-ai-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #ddd;
  flex-shrink: 0;
}
.code-ai-header .header-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.code-ai-header .header-title i {
  font-size: 20px;
  color: #5e60ce;
}
.code-ai-header .header-title h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #475569;
}
.code-ai-header .close-btn {
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #333;
  transition: color 0.2s ease;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}
.code-ai-header .close-btn:hover {
  color: #dc3545;
  background-color: #fee;
}
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading-overlay .spinner-container {
  text-align: center;
  color: white;
}
.loading-overlay .spinner-container i {
  margin-bottom: 15px;
}
.loading-overlay .spinner-container .loading-text {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.3px;
}
.code-ai-body {
  padding: 15px;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
}
.code-ai-body::-webkit-scrollbar {
  width: 8px;
}
.code-ai-body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.code-ai-body::-webkit-scrollbar-thumb {
  background: #c1c9d6;
  border-radius: 4px;
}
.code-ai-body::-webkit-scrollbar-thumb:hover {
  background: #a0a9b8;
}
.alert {
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  line-height: 1.5;
  animation: slideDown 0.3s ease;
}
.alert i {
  font-size: 18px;
  flex-shrink: 0;
}
.alert.alert-danger {
  background-color: #fee;
  border: 1px solid #fcc;
  color: #c33;
}
.alert.alert-danger i {
  color: #dc3545;
}
.alert.alert-warning {
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  color: #856404;
}
.alert.alert-warning i {
  color: #ff9800;
}
.alert.alert-info {
  background-color: #d1ecf1;
  border: 1px solid #bee5eb;
  color: #0c5460;
}
.alert.alert-info i {
  color: #17a2b8;
}
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.edit-info-message {
  margin-bottom: 20px;
  padding: 14px 16px;
  background:
    linear-gradient(
      135deg,
      #e0f2fe 0%,
      #bae6fd 100%);
  border-radius: 10px;
  border: 2px solid #7dd3fc;
  display: flex;
  align-items: center;
  gap: 12px;
  animation: slideDown 0.3s ease;
  box-shadow: 0 2px 8px rgba(14, 165, 233, 0.1);
}
.edit-info-message i {
  color: #0284c7;
  font-size: 18px;
  flex-shrink: 0;
}
.edit-info-message span {
  color: #0c4a6e;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.2px;
}
.current-code-section {
  margin-bottom: 20px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 10px;
  border: 2px solid #e0e4e8;
  animation: slideDown 0.3s ease;
}
.current-code-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.current-code-section .section-header .section-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #475569;
  font-size: 14px;
}
.current-code-section .section-header .section-label i {
  color: #6366f1;
  font-size: 16px;
}
.current-code-section .section-header .btn-toggle-code {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: white;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
  transition: all 0.2s ease;
}
.current-code-section .section-header .btn-toggle-code:hover {
  background: #f1f5f9;
  border-color: #94a3b8;
  color: #475569;
}
.current-code-section .section-header .btn-toggle-code i {
  font-size: 12px;
}
.current-code-section .code-display {
  margin-top: 12px;
  animation: fadeIn 0.3s ease;
}
.current-code-section .code-display .code-readonly {
  background: #ffffff;
  color: #1e293b;
  padding: 16px;
  border-radius: 8px;
  overflow-x: auto;
  font-family:
    "Consolas",
    "Monaco",
    "Courier New",
    monospace;
  font-size: 13px;
  line-height: 1.6;
  max-height: 250px;
  border: 1px solid #e2e8f0;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
}
.current-code-section .code-display .code-readonly code {
  color: #1e293b;
  display: block;
  white-space: pre;
  word-wrap: normal;
}
.current-code-section .code-display .code-readonly::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}
.current-code-section .code-display .code-readonly::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}
.current-code-section .code-display .code-readonly::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
.current-code-section .code-display .code-readonly::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.quick-actions-section {
  margin-bottom: 20px;
  animation: slideDown 0.3s ease;
}
.quick-actions-section .section-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #475569;
  font-size: 14px;
  margin-bottom: 12px;
}
.quick-actions-section .section-label i {
  color: #5e60ce;
  font-size: 16px;
}
.quick-actions-section .quick-actions-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.quick-actions-section .quick-actions-grid .quick-action-btn {
  background-color: #eef1f8;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #d0d7e2;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
}
.quick-actions-section .quick-actions-grid .quick-action-btn .quick-action-icon {
  font-size: 20px;
  color: #5e60ce;
}
.quick-actions-section .quick-actions-grid .quick-action-btn .quick-action-label {
  font-size: 13px;
  font-weight: 500;
  color: #475569;
}
.quick-actions-section .quick-actions-grid .quick-action-btn:hover:not(:disabled) {
  background-color: #dde4f1;
  border-color: #b2bed6;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
}
.quick-actions-section .quick-actions-grid .quick-action-btn:active:not(:disabled) {
  transform: translateY(0);
}
.quick-actions-section .quick-actions-grid .quick-action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.mode-selection {
  margin-bottom: 20px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e0e4e8;
}
.mode-selection .mode-label {
  font-weight: 600;
  margin-bottom: 10px;
  display: block;
  color: #475569;
  font-size: 14px;
}
.mode-selection .mode-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.mode-selection .mode-options .radio-option {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: background-color 0.2s ease;
}
.mode-selection .mode-options .radio-option:hover {
  background-color: #fff;
}
.mode-selection .mode-options .radio-option input[type=radio] {
  cursor: pointer;
  margin-right: 10px;
  accent-color: #5e60ce;
}
.mode-selection .mode-options .radio-option span {
  color: #4b5563;
  font-size: 14px;
}
.prompt-section {
  margin-bottom: 20px;
  position: relative;
}
.prompt-section .prompt-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.prompt-section .prompt-header .prompt-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #475569;
  font-size: 14px;
}
.prompt-section .prompt-header .prompt-label i {
  color: #5e60ce;
  font-size: 16px;
}
.prompt-section .prompt-header .btn-undo {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background:
    linear-gradient(
      135deg,
      #f59e0b 0%,
      #d97706 100%);
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 6px rgba(245, 158, 11, 0.3);
}
.prompt-section .prompt-header .btn-undo:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(245, 158, 11, 0.4);
  background:
    linear-gradient(
      135deg,
      #d97706 0%,
      #b45309 100%);
}
.prompt-section .prompt-header .btn-undo:active:not(:disabled) {
  transform: translateY(0);
}
.prompt-section .prompt-header .btn-undo:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.prompt-section .prompt-header .btn-undo i {
  font-size: 12px;
}
.prompt-section .prompt-textarea {
  width: 100%;
  min-height: 120px;
  padding: 12px;
  padding-right: 60px;
  padding-bottom: 50px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 14px;
  font-family:
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    "Helvetica Neue",
    Arial,
    sans-serif;
  resize: vertical;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.prompt-section .prompt-textarea:focus {
  outline: none;
  border-color: #5e60ce;
  box-shadow: 0 0 0 3px rgba(94, 96, 206, 0.1);
}
.prompt-section .prompt-textarea:disabled {
  background-color: #f1f5f9;
  cursor: not-allowed;
}
.prompt-section .btn-generate {
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 45px;
  height: 45px;
  padding: 0;
  background-color: #5e60ce;
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(94, 96, 206, 0.3);
  z-index: 10;
}
.prompt-section .btn-generate i {
  font-size: 18px;
}
.prompt-section .btn-generate:hover:not(:disabled) {
  background-color: #4d4fc7;
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(94, 96, 206, 0.4);
}
.prompt-section .btn-generate:active:not(:disabled) {
  transform: scale(1);
}
.prompt-section .btn-generate:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #9ca3af;
}
@keyframes gradient-rotate {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@keyframes sparkle {
  0%, 100% {
    opacity: 1;
    transform: scale(1) rotate(0deg);
  }
  33% {
    opacity: 0.85;
    transform: scale(1.08) rotate(8deg);
  }
  66% {
    opacity: 0.85;
    transform: scale(1.08) rotate(-8deg);
  }
}
@keyframes sparkle-intense {
  0%, 100% {
    opacity: 1;
    transform: scale(1) rotate(0deg);
  }
  25% {
    opacity: 0.7;
    transform: scale(1.2) rotate(15deg);
  }
  50% {
    opacity: 1;
    transform: scale(1) rotate(0deg);
  }
  75% {
    opacity: 0.7;
    transform: scale(1.2) rotate(-15deg);
  }
}
.presets-section {
  margin-top: 20px;
  margin-bottom: 20px;
}
.presets-section .presets-header {
  margin-bottom: 15px;
}
.presets-section .presets-header .presets-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #475569;
  font-size: 14px;
}
.presets-section .presets-header .presets-label i {
  color: #5e60ce;
  font-size: 16px;
}
.presets-section .presets-header .category-filter {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.presets-section .presets-header .category-filter .category-btn {
  padding: 6px 12px;
  background: #f1f5f9;
  border: 1px solid #e0e4e8;
  border-radius: 20px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #64748b;
  font-weight: 500;
}
.presets-section .presets-header .category-filter .category-btn.active {
  background: #5e60ce;
  color: white;
  border-color: #5e60ce;
}
.presets-section .presets-header .category-filter .category-btn:hover:not(.active) {
  background: #e0e4e8;
  border-color: #cbd5e1;
}
.presets-section .presets-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.presets-section .presets-grid .preset-card {
  background-color: #eef1f8;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #d0d7e2;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
}
.presets-section .presets-grid .preset-card .preset-icon {
  font-size: 20px;
  color: #5e60ce;
}
.presets-section .presets-grid .preset-card .preset-label {
  font-size: 13px;
  font-weight: 500;
  color: #475569;
}
.presets-section .presets-grid .preset-card:hover {
  background-color: #dde4f1;
  border-color: #b2bed6;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
}
.presets-section .presets-grid .preset-card:active {
  transform: translateY(0);
}
.preview-section {
  margin-top: 24px;
  padding: 20px;
  background:
    linear-gradient(
      135deg,
      #f8fafc 0%,
      #f1f5f9 100%);
  border-radius: 12px;
  border: 2px solid #e0e4e8;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  animation: slideUp 0.4s ease;
}
.preview-section .preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #e0e4e8;
}
.preview-section .preview-header .preview-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #1e293b;
  font-size: 16px;
}
.preview-section .preview-header .preview-label i {
  color: #10b981;
  font-size: 20px;
}
.preview-section .preview-header .btn-copy {
  padding: 8px 16px;
  background: white;
  border: 1px solid #e0e4e8;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #64748b;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.preview-section .preview-header .btn-copy:hover {
  background: #f8fafc;
  border-color: #5e60ce;
  color: #5e60ce;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(94, 96, 206, 0.15);
}
.preview-section .preview-header .btn-copy:active {
  transform: translateY(0);
}
.preview-section .preview-header .btn-copy.copied {
  background: #d1fae5;
  border-color: #10b981;
  color: #059669;
}
.preview-section .preview-header .btn-copy.copied i {
  color: #10b981;
}
.preview-section .preview-header .btn-copy i {
  font-size: 14px;
}
.preview-section .code-explanation {
  display: flex;
  align-items: start;
  gap: 12px;
  padding: 14px 16px;
  background: #e0f2fe;
  border-left: 4px solid #0284c7;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(2, 132, 199, 0.1);
  animation: fadeIn 0.3s ease;
}
.preview-section .code-explanation i {
  color: #0369a1;
  margin-top: 3px;
  font-size: 18px;
  flex-shrink: 0;
}
.preview-section .code-explanation p {
  margin: 0;
  color: #0c4a6e;
  font-size: 14px;
  line-height: 1.6;
  font-weight: 500;
}
.preview-section .code-preview {
  background: #ffffff;
  color: #1e293b;
  padding: 20px;
  border-radius: 12px;
  overflow-x: auto;
  margin-bottom: 20px;
  font-family:
    "Consolas",
    "Monaco",
    "Courier New",
    monospace;
  font-size: 14px;
  line-height: 1.7;
  max-height: 400px;
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  counter-reset: line;
}
.preview-section .code-preview::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 40px;
  background:
    linear-gradient(
      180deg,
      rgba(248, 250, 252, 0.9) 0%,
      transparent 100%);
  pointer-events: none;
  border-radius: 12px 12px 0 0;
}
.preview-section .code-preview code {
  color: #1e293b;
  display: block;
  white-space: pre;
  word-wrap: normal;
  padding-left: 3.5em;
  position: relative;
}
.preview-section .code-preview code .selector {
  color: #0369a1;
  font-weight: 600;
}
.preview-section .code-preview code .property {
  color: #7c3aed;
  font-weight: 500;
}
.preview-section .code-preview code .value {
  color: #ca8a04;
  font-weight: 500;
}
.preview-section .code-preview code .comment {
  color: #64748b;
  font-style: italic;
}
.preview-section .code-preview code .tag {
  color: #db2777;
  font-weight: 500;
}
.preview-section .code-preview code .keyword {
  color: #9333ea;
  font-weight: 600;
}
.preview-section .code-preview code .function {
  color: #059669;
  font-weight: 500;
}
.preview-section .code-preview code .string {
  color: #d97706;
  font-weight: 500;
}
.preview-section .code-preview code .number {
  color: #dc2626;
  font-weight: 500;
}
.preview-section .code-preview code::before {
  counter-increment: line;
  content: counter(line);
  display: inline-block;
  width: 3em;
  margin-left: -3.5em;
  margin-right: 0.5em;
  text-align: right;
  color: #94a3b8;
  -webkit-user-select: none;
  user-select: none;
  border-right: 2px solid #e2e8f0;
  padding-right: 0.5em;
  font-weight: 500;
}
.preview-section .code-preview::-webkit-scrollbar {
  height: 10px;
  width: 10px;
}
.preview-section .code-preview::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 6px;
}
.preview-section .code-preview::-webkit-scrollbar-thumb {
  background:
    linear-gradient(
      135deg,
      #cbd5e1 0%,
      #94a3b8 100%);
  border-radius: 6px;
  border: 2px solid #f1f5f9;
}
.preview-section .code-preview::-webkit-scrollbar-thumb:hover {
  background:
    linear-gradient(
      135deg,
      #94a3b8 0%,
      #64748b 100%);
}
.preview-section .code-preview::-webkit-scrollbar-corner {
  background: #f1f5f9;
}
.preview-section .preview-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #e0e4e8;
}
.preview-section .preview-actions .btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.preview-section .preview-actions .btn i {
  font-size: 14px;
}
.preview-section .preview-actions .btn.btn-secondary {
  background: white;
  color: #64748b;
  border: 2px solid #e0e4e8;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.preview-section .preview-actions .btn.btn-secondary:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
  color: #475569;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.preview-section .preview-actions .btn.btn-primary {
  background:
    linear-gradient(
      135deg,
      #10b981 0%,
      #059669 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
  border: 2px solid transparent;
}
.preview-section .preview-actions .btn.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
  background:
    linear-gradient(
      135deg,
      #059669 0%,
      #047857 100%);
}
.preview-section .preview-actions .btn.btn-primary:active {
  transform: translateY(0);
}
.preview-section .preview-actions .btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none !important;
}
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/*# sourceMappingURL=code-ai-assistant.component.css.map */
